export const ANSWER = "ANSWER";
export const ANSWER_MEMBER = "ANSWER_MEMBER";

export const GET_RELATE_INFO = "GET_RELATE_INFO";

//添加其他公司保单
export const SAVE_POLICY = 'SAVE_POLICY';
export const UPDATE_POLICY = 'UPDATE_POLICY';
export const DELETE_POLICY = 'DELETE_POLICY';
export const GET_POLICY_LIST = 'GET_POLICY_LIST';